import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { createFocusTrap } from 'focus-trap';

export default class DrawerToggle {

	constructor(element) {
		this.handleChange = this.handleChange.bind(this);
		this.element = element;
		this.masthead = document.getElementById('masthead');
		this.checkbox = (this.element instanceof HTMLElement) ? this.element.querySelector('.gigs-drawer-toggle__checkbox') : undefined;
		this.drawer = document.getElementById('drawer');
		this.openClass = 'gigs-drawer--open';
		this.wpAdminBar = document.getElementById('wpadminbar');
		this.focusableElements = [this.drawer, this.masthead];
		if (this.wpAdminBar) this.focusableElements.push(this.wpAdminBar);
	}

	init() {
		if (this.checkbox instanceof HTMLElement) {
			this.checkbox.addEventListener('change', this.handleChange);
		}
		this.initFocusTrap();
	}

	destroy() {
		if (this.checkbox instanceof HTMLElement) {
			this.checkbox.removeEventListener('change', this.handleChange);
		}
		this.destroyFocusTrap();
	}

	initFocusTrap() {
		this.focusTrap = createFocusTrap(this.focusableElements, {
			onDeactivate: () => this.close(),
		});
	}

	destroyFocusTrap() {
		if (this.focusTrap) {
			this.focusTrap.deactivate();
			this.focusTrap = null;
		}
	}

	open() {
		if (this.drawer instanceof HTMLElement) {
			this.drawer.classList.add(this.openClass);
			this.focusTrap.activate();
			disableBodyScroll(this.drawer);

		}
		if (this.checkbox instanceof HTMLInputElement) {
			if (! this.checkbox.checked) {
				this.checkbox.checked = true;
			}
		}
	}

	close() {
		if (this.drawer instanceof HTMLElement) {
			this.drawer.classList.remove(this.openClass);
			this.focusTrap.deactivate();
			enableBodyScroll(this.drawer);
		}
		if (this.checkbox instanceof HTMLInputElement) {
			if (this.checkbox.checked) {
				this.checkbox.checked = false;
			}
		}
	}

	handleChange(e) {
		const { checked } = e.target;
		if (checked) {
			this.open();
		} else {
			this.close();
		}
	}
}
